import React, { useState, useCallback, useEffect, forwardRef } from "react";
import { FormLayout, TextField, Text } from "@shopify/polaris";

const PaddingStyle = (props) => {
  const handleChangePaddingTop = (newValue) => {
    props.handleChangePaddingTop(newValue);
  };
  const handleChangePaddingBottom = (newValue) => {
    props.handleChangePaddingBottom(newValue);
  };
  const handleChangePaddingLeft = (newValue) => {
    props.handleChangePaddingLeft(newValue);
  };
  const handleChangePaddingRight = (newValue) => {
    props.handleChangePaddingRight(newValue);
  };
  const handleChangePaddingTopMobile = (newValue) => {
    props.handleChangePaddingTopMobile(newValue);
  };
  const handleChangePaddingBottomMobile = (newValue) => {
    props.handleChangePaddingBottomMobile(newValue);
  };
  const handleChangePaddingLeftMobile = (newValue) => {
    props.handleChangePaddingLeftMobile(newValue);
  };
  const handleChangePaddingRightMobile = (newValue) => {
    props.handleChangePaddingRightMobile(newValue);
  };

  return (
    <FormLayout>
      <Text variant="headingSm" as="h6">
        SECTION PADDING
      </Text>
      <FormLayout.Group condensed>
        <FormLayout>
          <Text variant="headingXs" as="h6">
            DESKTOP
          </Text>
          <TextField
            label="Padding Top"
            value={
              props?.item?.padding?.top?.desktop
                ? props?.item?.padding?.top?.desktop
                : ""
            }
            onChange={handleChangePaddingTop}
            type="number"
          />
          <TextField
            label="Padding Bottom"
            value={
              props?.item?.padding?.bottom?.desktop
                ? props?.item?.padding?.bottom?.desktop
                : ""
            }
            onChange={handleChangePaddingBottom}
            type="number"
          />
          <TextField
            label="Padding Left"
            value={
              props?.item?.padding?.left?.desktop
                ? props?.item?.padding?.left?.desktop
                : ""
            }
            onChange={handleChangePaddingLeft}
            type="number"
          />
          <TextField
            label="Padding Right"
            value={
              props?.item?.padding?.right?.desktop
                ? props?.item?.padding?.right?.desktop
                : ""
            }
            onChange={handleChangePaddingRight}
            type="number"
          />
        </FormLayout>
        <FormLayout>
          <Text variant="headingXs" as="h6">
            MOBILE
          </Text>
          <TextField
            label="Padding Top"
            value={
              props?.item?.padding?.top?.mobile
                ? props?.item?.padding?.top?.mobile
                : ""
            }
            onChange={handleChangePaddingTopMobile}
            type="number"
          />
          <TextField
            label="Padding Bottom"
            value={
              props?.item?.padding?.bottom?.mobile
                ? props?.item?.padding?.bottom?.mobile
                : ""
            }
            onChange={handleChangePaddingBottomMobile}
            type="number"
          />
          <TextField
            label="Padding Left"
            value={
              props?.item?.padding?.left?.mobile
                ? props?.item?.padding?.left?.mobile
                : ""
            }
            onChange={handleChangePaddingLeftMobile}
            type="number"
          />
          <TextField
            label="Padding Right"
            value={
              props?.item?.padding?.right?.mobile
                ? props?.item?.padding?.right?.mobile
                : ""
            }
            onChange={handleChangePaddingRightMobile}
            type="number"
          />
        </FormLayout>
      </FormLayout.Group>
    </FormLayout>
  );
};

export default PaddingStyle;
